import { BackgroundProps } from './component';

export type BackgroundRendererProps = BackgroundProps;
